<template>
  <div>
    <div class="story">
      <div class="block">
        <div>To my Flamingo Strawberry Ice Cream.</div>
        <div @click="play" class="play">play</div>
      </div>
      <div class="block" style="font-size: 85px">🦩🍓🍨</div>
      <!-- <div class="block">
        We've done {{ sessions.length }} sessions together.
      </div> -->
      <div class="block">
        <div class="datetime">May 3</div>
        <br />
        <div>... Robert messages Nessrine on Mooclab.</div>
      </div>
      <div class="block">
        <div>...3 days pass.</div>
        <br />
        <div>No reply.</div>
      </div>
      <div class="block">
        <div>...6 days pass.</div>
        <br />
        <div>Still no reply.</div>
      </div>
      <div class="block">
        <div>
          It's beginning to look like Nessrine and Robert will never meet in
          this universe.
        </div>
      </div>
      <div class="block">
        <div>...10 days pass.</div>
      </div>
      <div class="block">
        <div class="datetime">May 13</div>
        <br />
        <div>Nessrine replies to Robert on Mooclab.</div>
        <div>She wants to try out Cofocus.</div>
      </div>
      <div class="block">
        <div>Robert replies to Ness.</div>
        <div>She signs up.</div>
      </div>
      <div class="block">
        <div>Phew.</div>
      </div>
      <div class="block">
        <div>Looks like they'll be meeting each other after all...!</div>
      </div>
      <div class="block">
        <div class="datetime">May 14, 3:45PM</div>
        <br />
        <div>Nessrine and Robert meet for the first time.</div>
      </div>
      <div class="block">
        <div>They have two sessions in row.</div>
        <div>Their third session on the 16th of May...</div>
      </div>
      <div class="block">
        <div>2 days pass without any sessions between the two. Is that it?</div>
      </div>
      <div class="block">
        <div class="datetime">May 19</div>
        <br />
        <div>They have another session.</div>
      </div>
      <div class="block">
        <div>Wait...</div>
      </div>
      <div class="block">
        <div>It looks like something went really well...</div>
      </div>
      <div class="block">
        <div>It seems they're beginning to bond!</div>
      </div>
      <div class="block">
        <div>
          That day Robert discovers more about Ness's background in business and
          finance and startups.
        </div>
        <br />
        <div>
          But also of Ness's interest in coding. They decide on that very day to
          do a coding lesson together. They also already discuss potential
          collaboration.
        </div>
      </div>
      <div class="block">
        <div>
          The same evening Ness sends Robert a message by which Robert is
          seriously amazed by.
        </div>
      </div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-08-02_at_10.48.19_XDSprRbFD.png"
      />
      <div class="block">
        <div>
          They begin chatting more and they have 8 more sessions that week.
        </div>
      </div>
      <div class="block">
        <div>...and 22 sessions the week after.</div>
      </div>
      <div class="block">
        <div class="datetime">May 27, 3PM</div>
        <br />
        <div>
          In that same week, they have their first coding session. They're
          having a good time together.
        </div>
      </div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-08-02_at_11.24.32_O7UpPGjnR1N.png"
      />
      <div class="block">
        <div>They continue to have many sessions.</div>
      </div>
      <div class="block">
        <div class="datetime">May 31</div>
        <br />
        <div>Nessrine does her 100th session solo!</div>
        <br />
        <div>
          Robert creates a badge for her that doesn't turn out too well but she
          likes it anyway!
        </div>
      </div>
      <div class="block">
        <div class="datetime">June 1st</div>
        <br />
        <div>
          Nessrine invites Robert to play Scribble around midnight. Robert wins
          twice, Ness once!
        </div>
        <br />
        <div>Ness promises there will be payback!</div>
      </div>
      <div class="block">They get along really wholesomely.</div>
      <div class="block">
        <div>
          Ness approaches her exams. She spends less time in sessions...
        </div>
        <br />
        <div>A brief period of quiet...</div>
      </div>
      <div class="block">
        <div class="datetime">June 15</div>
        <br />
        <div>
          The day arrives that Robert & Ness have their Cofocus collaboration
          call at 5PM. Questions are asked. Some fun is had.
        </div>
        <br />
        <div>It is decided. Ness joins Cofocus.</div>
      </div>
      <div class="block">
        <div>Nessrine gets to work right away, and starts working hard.</div>
        <br />
        <div>Robert is impressed.</div>
      </div>
      <div class="block">
        <div class="datetime">June 21</div>
        <br />
        <div>
          Ness goes all out with chilli in between sessions and ends up getting
          a bunch of it on her face. Robert offers to cover a session in her
          place. She refuses and goes for the session.
        </div>
        <br />
        <div>
          Robert is convinced this is one badass girl and is glad to have her as
          part of Cofocus.
        </div>
      </div>
      <div class="block">
        <div>
          That same day, Ness & Rob do their first workout together at 7:30PM.
        </div>
        <br />
        <div>That session also happened to be Ness's 200th session.</div>
      </div>
      <div class="block">
        <div class="datetime">July 5th, 10:57PM</div>
        <br />
        Random fact: Ness uses the 'tea brb' for the first time.
      </div>
      <div class="block">
        <div>And the work continues. And so does the play.</div>
        <div>
          It seems there's something magical in the air whenever the two meet.
        </div>
      </div>
      <div class="block">
        <div>Ness teaches Rob Arabic.</div>
        <br />
        <div>Rob can't get enough of having fun with the letter ظ.</div>
      </div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-08-02_at_13.56.35_1jCFY6-mR.png"
      />
      <div class="block">
        <div>Rob gives Ness a few more professional coding lessons...</div>
      </div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-08-02_at_14.05.00__2wee9xqf.png"
      />
      <div class="block">
        <div>
          They continue getting to know each other more. Finding more and more
          things in common.
        </div>
        <br />
        <div>
          Then they spend time listening to music. Singing together. Trying out
          outfits. Playing with dogs. Belly dancing. And just goofing around
          having a really great time!
        </div>
      </div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-07-22_at_03.04.32_xLNI8VRp8XB.png"
      />
      <div class="block">
        This isn't just work and skill exchange anymore... is it?
      </div>
      <div class="block">
        <div class="datetime">July 26, 3:20AM</div>
        <br />
        <div>
          After several visits to the bathroom by Robert to pee, and after
          multiple masterfully awkward back-and-forths that lead Nessrine's
          receptors to become charged, buzzed and trying to make sense of what
          this Robert is going on about...
        </div>
      </div>
      <div class="block">
        <div>
          ... and with the help of Nessrine putting on her top notch Bobina +
          Mustache game, Robert moves towards a confession of his feelings...
        </div>
      </div>
      <div class="block">
        <div>
          "I like you", said Rob, as Ness's face acquired a smile. "And I like
          you a little more than just..." continues Rob.
        </div>
      </div>
      <div class="block">
        <div>
          ... and he goes on rambling about being understanding if she doesn't
          feel the same, and how he'll be professional about it, but that he'd
          rather live in a reality where he gives this a shot than not, when
          Ness jumps in: "I guess it's time for me to say something."
        </div>
      </div>
      <div class="block">
        <div>Ness: "I like you too."</div>
      </div>
      <img
        class="image"
        src="https://images.unsplash.com/photo-1578935550215-49da6824dae3"
      />
      <div class="block">You are my magic Nessrine.</div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-07-26_at_05.19.54_ElFjMyBtv.png"
      />
      <div class="block">I really like you Nessrine.</div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-07-19_at_03.23.42_suoOSWIJP.png"
      />
      <div class="block">And I really want to co-experience life with you.</div>
      <img
        class="image"
        src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-07-20_at_01.25.41_mIRqxMOKI.png"
      />
      <div class="block">
        I want to know you fully, and I want to be there through it all.
      </div>
      <div class="block">
        I want to be there to make you laugh and see you smile and glow and have
        your receptors make an appearance. I want to be sweet with you and I
        want to be sexy with you. I want to breakfast in bed with you. And I
        want to be there through all the moods, through the fears, through every
        period cramp, and any time you get sick. I'm here for the full package
        with the name Nessrine Tbessi!
      </div>
      <div class="block">
        <div>I can't wait for what's next.</div>
        <br />
        <div>
          And just as much, I want to savor and indulge fully in each moment
          with you. It's really fun with you. It's really great with you.
        </div>
      </div>
      <div class="block" style="font-size: 85px">❤️</div>
      <div class="block">Continued...</div>
      <div class="block">
        Ever since the two discovered they like each other...
      </div>
      <div class="block">
        Ness & Rob started working out together on camera and they've been
        loving it. Very coincidentally and unrelated, Rob's shirts have been
        perpetually disappearing from his body!
      </div>
      <div class="block">Falling asleep on camera together!</div>
      <div class="block">Prolonged eye contact!</div>
      <div class="block">Room temperatures have significantly gone up!</div>
      <div class="block">
        <div class="datetime">July 31</div>
        <br />
        <div>Peaches. Nuff' said.</div>
      </div>
      <div class="block">
        <div class="datetime">August 2</div>
        <br />
        <div>
          Robert gave a strictly professional intro course on how-to-magic-mike.
          Robert also did some illegal, ungodly acts on grapes. Rumor has it
          Ness may have enjoyed it.
        </div>
      </div>
      <div
        class="block"
        style="background-color: #7a00ff; color: white; font-size: 48px"
      >
        Happy 500 Ness!!! ❤️
      </div>
      <div class="block">Hold on a second...</div>
      <iframe
        class="video"
        width="800"
        height="450"
        src="https://www.youtube.com/embed/dQw4w9WgXcQ"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <div class="block">
        <div>
          The words may fall short of something profound. But every time I'm
          with you I'm just glad you're around.
        </div>
      </div>
      <!-- Outro song -->
      <!-- That Girl song -->
      <!-- Make You Happy -->
      <!-- You and me, always forever. -->

      <!-- Make my narration of this. -->
    </div>
  </div>
</template>

<script>
// import { getSessionsForIDs } from "./InternalRequests";
export default {
  name: "Flamingo",
  mounted() {
    // let audio = new Audio(require("./Ness/us.mp3"));
    //   audio.file.currentTime = 0;
    //   audio.file.isPlaying = true;
    //   audio.file.volume = 0.5;
    // audio.play();
  },
  methods: {
    play() {
      let audio = new Audio(require("./Ness/us.mp3"));
      audio.currentTime = 0;
      audio.isPlaying = true;
      audio.volume = 0.5;
      audio.play();
    },
  },
  //   async created() {
  //     await this.getSessionsForIDs();
  //   },
  //   data() {
  //     return {
  //       UID_1: "5ffa95888d24191c09f7f0bb",
  //       UID_2: "609e51f7a601860015b41871",
  //       sessions: null,
  //       one: "",
  //       two: "",
  //       three: "",
  //       four: "",
  //       five: "",
  //       six: "",
  //       seven: "",
  //       eight: "",
  //       nine: "",
  //       ten: "",
  //     };
  //   },
  //   methods: {
  //     async getSessionsForIDs() {
  //       this.sessions = await getSessionsForIDs(this.UID_1, this.UID_2);
  //       this.one = this.sessions[99];
  //       this.two = this.sessions[199];
  //       this.three = this.sessions[299];
  //       this.four = this.sessions[399];
  //       this.five = this.sessions[499];
  //       this.six = this.sessions[599];
  //       this.seven = this.sessions[699];
  //       this.eight = this.sessions[799];
  //       this.nine = this.sessions[899];
  //       this.ten = this.sessions[999];
  //     },
  //   },
  //   computed: {
  //     firstSession() {
  //       let sessions = this.sessions;
  //       sessions = sessions.sort(function (a, b) {
  //         return new Date(a.dateTime) - new Date(b.dateTime);
  //       });
  //       return sessions[0];
  //     },
  //   },
};
</script>
<style scoped>
.story {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.block {
  width: 800px;
  margin: 10px auto;
  margin-bottom: 30px;
  height: 500px;
  border: 10px double black;
  border-radius: 3px;
  background-color: white;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 60px;
  text-align: center;
}
.image {
  width: 800px;
  margin: 10px auto;
  margin-bottom: 30px;
  border-radius: 3px;
}
.datetime {
  background-color: #4b00ff;
  border-radius: 360px;
  padding: 3px 20px;
  color: white;
  font-size: 24px;
  font-weight: 700;
}
.video {
  margin: 10px auto;
  margin-bottom: 30px;
  border-radius: 3px;
}
.play {
  border-radius: 360px;
  background-color: blueviolet;
  color: white;
  padding: 0px 10px;
}
</style>